/* One-time file handoff from the home page to the existing builder upload engine. */
(() => {
  const STORE = 'files';
  const open = () => new Promise((resolve, reject) => {
    const request = indexedDB.open('BuyDTFHomeUploads', 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    request.onblocked = () => reject(new Error('Storage is busy'));
  });
  const transaction = async (mode, action) => {
    const db = await open();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, mode);
      const request = action(tx.objectStore(STORE));
      tx.oncomplete = () => { db.close(); resolve(request?.result); };
      tx.onabort = tx.onerror = () => { db.close(); reject(tx.error || new Error('Storage unavailable')); };
    });
  };
  window.DTFUploadHandoff = {
    async stage(files) {
      const id = crypto.randomUUID();
      await transaction('readwrite', store => {
        // Abandoned selections are temporary, not a second saved order.
        const cursor = store.openCursor();
        cursor.onsuccess = () => {
          const entry = cursor.result;
          if (!entry) return;
          if (Date.now() - entry.value.createdAt > 86400000) entry.delete();
          entry.continue();
        };
        return store.put({files: Array.from(files), createdAt: Date.now()}, id);
      });
      return id;
    },
    read: id => transaction('readonly', store => store.get(id)),
    remove: id => transaction('readwrite', store => store.delete(id))
  };

  const block = document.querySelector('[data-home-upload]');
  if (!block) return;
  const input = block.querySelector('input[type=file]');
  const button = block.querySelector('button');
  const status = block.querySelector('[role=status]');
  let busy = false;
  const upload = async selected => {
    const files = Array.from(selected || []);
    if (busy || !files.length) return;
    if (files.some(file => !file.name.toLowerCase().endsWith('.png'))) {
      status.textContent = block.dataset.invalid;
      return;
    }
    busy = true; button.disabled = true; input.disabled = true;
    block.setAttribute('aria-busy', 'true');
    status.textContent = block.dataset.opening;
    try {
      const id = await window.DTFUploadHandoff.stage(files);
      const target = new URL(block.dataset.builderUrl, location.href);
      // Keep Shopify's preview on the same draft when following a preview URL.
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id', preview);
      target.searchParams.set('upload', id);
      location.assign(target.href);
    } catch (error) {
      console.warn('File handoff could not be saved:', error);
      status.textContent = block.dataset.failed;
      busy = false; button.disabled = false; input.disabled = false;
      block.removeAttribute('aria-busy');
    }
  };
  button.addEventListener('click', () => input.click());
  input.addEventListener('change', () => { upload(input.files); input.value = ''; });
  let dragDepth = 0;
  block.addEventListener('dragenter', event => { event.preventDefault(); dragDepth++; block.classList.add('is-dragging'); });
  block.addEventListener('dragover', event => event.preventDefault());
  block.addEventListener('dragleave', () => { if (--dragDepth <= 0) block.classList.remove('is-dragging'); });
  block.addEventListener('drop', event => {
    event.preventDefault(); dragDepth = 0; block.classList.remove('is-dragging'); upload(event.dataTransfer.files);
  });
})();
